import React from 'react';
import { Image, Text } from '@asigna/kit';

import { targetIcon } from '../util/images';

interface NetworkCardProps {
  icon: string;
  title: string;
  link?: string;
  soon?: boolean;
  testnet?: boolean;
  handleClick: () => void;
}

export const NetworkCard: React.FC<NetworkCardProps> = ({
  icon,
  title,
  link,
  soon,
  testnet = false,
  handleClick,
}) => {
  return (
    <button
      className="flex items-center gap-8 py-8 px-16 w-full hover:bg-[#292A2F]"
      onClick={handleClick}
    >
      <div className="flex items-center gap-4">
        <div className="relative flex">
          <Image src={icon} size={24} className="" />
          {testnet && (
            <div className="absolute bg-success w-[10px] h-[10px] rounded-[50%] bottom-[-2px] right-[-2px] border-2 border-[#18181A]" />
          )}
        </div>
        <Text message={title} size="m12" />
      </div>
      {Boolean(link) && <Image src={targetIcon} size={16} className="ml-auto" />}
      {Boolean(soon) && <Text message="Soon" size="r12" color="regular" />}
    </button>
  );
};
